import { PermDeviceInformation } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { Alert, Box, Button, ButtonGroup, Grid, Input, Option, Select, Stack, Textarea, Typography } from "@mui/joy";
import { useState } from "react";
import { server_url } from '../core/config_geral'
import { Link } from "react-router-dom";
import axios from "axios";


function AdicionarContentPage() {

    var token = useSelector((state) => state.auth.token)
    const [state, setState] = useState({
        loading: false,
        information: "Enviar",
        error: null,
        descricao: null,
        titulo: null,
        badge: "",
        badges: [],
    })

    function updateAttribute(tag, valor) {
        setState(prev => ({
            ...prev,
            [tag]: valor
        }))
    }

    const registrarTrilha = async (titulo, descricao, badges) => {

        // return true;
        const formData = new FormData();
        const formToSend = {
            action: "CASTOR_CRIAR_NOVO_CONTENT_RPC",
            runNow: true,
            payload: JSON.stringify({
                descricao: descricao,
                titulo: titulo,
                badges: badges,
                mediasId: []
            }),
        };

        formData.append("file", null);
        formData.append(
            "data",
            new Blob([JSON.stringify(formToSend)], {
                type: "application/json",
            })
        );

        try {
            var r = await axios.post(server_url + "/rpc", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${token}`,
                },
                onUploadProgress: (progressEvent) => {

                },
            });

            return r;
        } catch (error) {
            console.log(error)
            return null;
        }
    }

    const addBadge = () => {
        if (state.badge == "" || state.badge.trim().length == 0 ) return;

        var b = [...state.badges]

        b.push(state.badge)

        setState(prev => ({
            ...prev,
            badge: "",
            badges: b
        }))
    }

    const removeBadge = (index) => {
        if(index == null || index < 0) return;

        var b =[...state.badges]

        b.splice(index, 1)

        setState(prev => ({
            ...prev,
            badges: b
        }))
    }

    async function enviar() {

        setState(prev => ({
            ...prev,
            error: null,
            information: "Enviando...",
            loading: true
        }))

        var error = null;
        if (state.descricao == null || state.descricao.length == 0)
            error = "Descrição inválida";
        else if (state.titulo == null || state.titulo.length == 0)
            error = "Título inválido";

        if (error != null)
            setState(prev => ({ ...prev, error, loading: false, information: "Enviar" }))
        else {
            setTimeout(() => {
                var r = registrarTrilha(state.titulo, state.descricao, state.badges)
                setTimeout(() => {
                    if (r == null)
                        setState(prev => ({
                            ...prev,
                            loading: false,
                            information: "Enviar",
                            error: "Erro ao registrar trilha (Vide Console)",
                        }))
                    else
                        setState(prev => ({
                            ...prev,
                            loading: false,
                            information: "Enviado!",
                            error: "SUCESSO!",
                        }))
                }, 500);
            }, 100)


        }
    }

    return <>
        <Grid xs={12}>
            <Stack spacing={1}>
                <Typography>
                    Cadastro Content
                </Typography>
                {state.error !== null && <Alert color="danger"> {state.error}</Alert>}
                <Input
                    disabled={state.loading}
                    placeholder="titulo"
                    onChange={(e) => {
                        updateAttribute("titulo", e.target.value)
                    }}></Input>
                <Textarea minRows={"10"} onChange={(e) => {
                    updateAttribute("descricao", e.target.value)
                }}></Textarea>
                <Box>
                    <Stack direction={"row"} spacing={1}>
                        <Input
                            disable={state.loading}
                            value={state.badge} 
                            placeholder="Descreva badge (#b#diamond#t#...)"
                            onChange={(e) => updateAttribute("badge", e.target.value)}
                            sx={{width: "100%"}}
                        ></Input>
                        <Button onClick={addBadge} disabled={state.loading} color="primary">+</Button>
                    </Stack>
                </Box>
                <Stack spacing={1}>
                    <Typography>
                        Badges:
                    </Typography>
                    {state.badges.map((e, index) => {
                        return <Box key={index}>
                            <Stack direction={"row"} spacing={1}> 
                                <Button color="danger" onClick={() => removeBadge(index)}>X</Button>
                                <Typography>
                                    {e}
                                </Typography>
                            </Stack>
                        </Box>
                    })}
                </Stack>
                <Button onClick={enviar} disabled={state.loading}>{state.information}</Button>
            </Stack>
        </Grid>
    </>
}

export default AdicionarContentPage